import React from 'react';
import Card3D from '../ui/Card3D';
import { Volunteer } from '../../types/team';
import { Instagram, Linkedin, Mail } from 'lucide-react';

interface VolunteerCardProps {
  volunteer: Volunteer;
}

const VolunteerCard: React.FC<VolunteerCardProps> = ({ volunteer }) => {
  return (
    <Card3D>
      <div className="bg-white rounded-xl shadow-lg">
        <div className="flex items-center space-x-4 p-6">
          <img 
            src={volunteer.image} 
            alt={volunteer.name}
            className="w-16 h-16 rounded-full object-cover"
          />
          <div>
            <h3 className="text-lg font-bold mb-1" style={{ color: volunteer.color }}>
              {volunteer.name}
            </h3>
            <p className="text-gray-600">{volunteer.role}</p>
          </div>
        </div>
      </div>
    </Card3D>
  );
};

export default VolunteerCard;